
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Row, Col } from "react-bootstrap";
// import Box from "@mui/material/Box";
// import Card from "@mui/material/Card";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import CardContent from "@mui/material/CardContent";
// import Typography from "@mui/material/Typography";
// import { toast } from "react-hot-toast";

// // Icons
// import DataUsageIcon from "@mui/icons-material/DataUsage";
// import SchoolIcon from "@mui/icons-material/School";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import NavigationIcon from "@mui/icons-material/Navigation";
// import BuildIcon from "@mui/icons-material/Build";
// import DomainIcon from "@mui/icons-material/Domain";
// import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
// import HistoryIcon from "@mui/icons-material/History";
// import PeopleIcon from "@mui/icons-material/People";
// import GavelIcon from "@mui/icons-material/Gavel";
// import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
// import Chip from "@mui/material/Chip";
// import { green, orange, red } from "@mui/material/colors";

// // My components
// import HeaderCard from "../../components/common/HeaderCard";

// // My css
// import css from "../../css/admin/home-page.module.css";

// import { SERVER_ORIGIN } from "../../utilities/constants";
// import Loader from "../../components/common/Loader";
// import { useUserType } from "../common/UserTypeContext";

// const EMServicePage = () => {
//   const { setUserTypeToChapterEM } = useUserType();
//   const [isLoading, setIsLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("overview");
//   const [hoveredCard, setHoveredCard] = useState(null);

//   // State for dynamic data
//   const [all_institutes, setAll_institutes] = useState(0);
//   const [all_school_counts, setall_school_counts] = useState(0);
//   const [all_yuva_terms_counts, setall_yuva_counts_counts] = useState(0);
//   const [all_thalir_terms_counts, setall_thalir_terms_counts] = useState(0);
//   const [all_mou_accepted, setAll_mou_accepted] = useState(0);
//   const [all_mou_rejected, setAll_mou_rejected] = useState(0);
//   const [all_mou_pending, setAll_mou_pending] = useState(0);
//   const [
//     all_institutes_onboarding_onboarded,
//     setAll_institutes_onboarding_onboarded,
//   ] = useState(0);
//   const [
//     all_institutes_onboarding_invited,
//     setAll_institutes_onboarding_invited,
//   ] = useState(0);
//   const [
//     all_institutes_onboarding_pending,
//     setAll_institutes_onboarding_pending,
//   ] = useState(0);

//   const [all_thalir_onboarding_onboarded, setAll_thalir_onboarding_onboarded] =
//     useState(0);
//   const [all_thalir_onboarding_invited, setAll_thalir_onboarding_invited] =
//     useState(0);
//   const [all_thalir_onboarding_pending, setAll_thalir_onboarding_pending] =
//     useState(0);
//   const [all_institutes_email_sent, setAll_institutes_email_sent] = useState(0);
//   const [all_institutes_email_not_sent, setAll_institutes_email_not_sent] =
//     useState(0);
//   const [isMouSigned, setIsMouSigned] = useState(false);
//   const [all_institutesStudents, setAll_institutesStudets] = useState(0);
//   const [all_schoolStudents_counts, setall_schoolStudents_counts] = useState(0);

//   // Additional metrics for dashboard
//   const [yuvaTcExpiringCount, setYuvaTcExpiringCount] = useState(0);
//   const [thalirTcExpiringCount, setThalirTcExpiringCount] = useState(0);
//   const [yuvaTcExpiredCount, setYuvaTcExpiredCount] = useState(0);
//   const [thalirTcExpiredCount, setThalirTcExpiredCount] = useState(0);

//   const navigate = useNavigate();

//   // Function to get font styles based on hover state
//   const getFontStyle = (cardType, type = "title") => {
//     const isHovered = hoveredCard === cardType;

//     switch (type) {
//       case "title":
//         return {
//           fontWeight: isHovered ? 700 : 600,
//           fontSize: isHovered ? "1.1rem" : "1rem",
//           color: isHovered ? "#1a56db" : "#2c3e50",
//           transition: "all 0.3s ease",
//         };
//       case "count":
//         return {
//           fontWeight: isHovered ? 800 : 700,
//           fontSize: isHovered ? "2.5rem" : "2.25rem",
//           color: isHovered ? "#1e40af" : "#2f80ed",
//           transition: "all 0.3s ease",
//         };
//       case "description":
//         return {
//           fontWeight: isHovered ? 500 : 400,
//           color: isHovered ? "#4b5563" : "#7f8c8d",
//           transition: "all 0.3s ease",
//         };
//       default:
//         return {};
//     }
//   };

//   // Function to get card style with hover effect
//   const getCardStyle = (cardType, index) => {
//     const isHovered = hoveredCard === cardType;
//     return {
//       padding: "15px",
//       textAlign: "left",
//       borderRadius: "12px",
//       boxShadow: isHovered
//         ? "0 8px 20px rgba(0,0,0,0.12)"
//         : "0 4px 12px rgba(0,0,0,0.08)",
//       height: "100%",
//       border: "none",
//       backgroundColor: "white",
//       transition: "all 0.3s ease",
//       transform: isHovered ? "translateY(-4px)" : "none",
//       cursor: "pointer",
//     };
//   };

//   // Function to fetch count data from API
//   const fetchCountData = async () => {
//     const em_id = sessionStorage.getItem("_id");
//     setIsLoading(true);
//     try {
//       // Add cache busting
//       const timestamp = new Date().getTime();
//       const response = await fetch(`${SERVER_ORIGIN}/api/em/auth/counting?_t=${timestamp}`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "auth-token": sessionStorage.getItem("token"),
//           "Cache-Control": "no-cache, no-store, must-revalidate",
//           "Pragma": "no-cache",
//         },
//         body: JSON.stringify({ _id: em_id }),
//       });

//       const result = await response.json();

//       if (response.status >= 400 && response.status < 600) {
//         if (response.status === 401) {
//           navigate("/login?userType=em");
//         } else {
//           toast.error("Failed to fetch data");
//         }
//       } else if (response.ok && response.status === 200) {
//         // Set data from API response
//         setAll_institutes(result.data.all_institutes || 0);
//         setAll_mou_accepted(result.data.all_mou_accepted || 0);
//         setAll_mou_rejected(result.data.all_mou_rejected || 0);
//         setAll_mou_pending(result.data.all_mou_pending || 0);
//         setall_school_counts(result.data.all_school_counts || 0);
//         setAll_institutes_onboarding_pending(
//           result.data.all_institutes_onboarding_pending || 0
//         );
//         setAll_institutes_onboarding_invited(
//           result.data.all_institutes_onboarding_invited || 0
//         );
//         setAll_institutes_email_sent(
//           result.data.all_institutes_email_sent || 0
//         );
//         setAll_institutes_onboarding_onboarded(
//           result.data.all_institutes_onboarding_onboarded || 0
//         );
//         // set thalir
//         setAll_thalir_onboarding_onboarded(
//           result.data.all_thalir_onboarding_onboarded || 0
//         );
//         setAll_thalir_onboarding_pending(
//           result.data.all_thalir_onboarding_pending || 0
//         );
//         setAll_thalir_onboarding_invited(
//           result.data.all_thalir_onboarding_invited || 0
//         );
//         // end of thalir counts
//         setAll_institutes_email_not_sent(
//           result.data.all_institutes_email_not_sent || 0
//         );
//         setall_thalir_terms_counts(result.data.thalir_termsAccepted || 0);
//         setall_yuva_counts_counts(result.data.yuva_termsAccepted || 0);

//         setAll_institutesStudets(result.data.all_yuvastudents_counts || 0);
//         setall_schoolStudents_counts(
//           result.data.all_thalirstudents_counts || 0
//         );
//       }
//     } catch (err) {
//       console.error(err.message);
//       toast.error("Failed to fetch data");
//     }
//     setIsLoading(false);
//   };

//   // Function to check MOU status
//   const checkMou = async () => {
//     try {
//       const response = await fetch(`${SERVER_ORIGIN}/api/em/auth/check-mou`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "auth-token": sessionStorage.getItem("token"),
//         },
//         body: JSON.stringify({ _id: sessionStorage.getItem("_id") }),
//       });

//       const result = await response.json();
//       if (response.status >= 200 && response.status < 300) {
//         setIsMouSigned(result.data.termsAccepted);
//       } else {
//         throw new Error("Failed to check MOU status");
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   // Function to verify token
//   const verifyToken = async () => {
//     try {
//       const response = await fetch(
//         `${SERVER_ORIGIN}/api/em/auth/verify-token`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "auth-token": sessionStorage.getItem("token"),
//           },
//         }
//       );

//       const result = await response.json();

//       if (response.status >= 400 && response.status < 600) {
//         if (response.status === 401) {
//           navigate("/login?userType=em");
//         }
//       }
//     } catch (err) {
//       console.error(err.message);
//     }
//   };

//   useEffect(() => {
//     setUserTypeToChapterEM();
//     verifyToken();
//     fetchCountData();
//     checkMou();
//   }, [setUserTypeToChapterEM, navigate]);

//   function handleInstitutesClick() {
//     navigate("/em/institute/all");
//   }

//   function handleMassEmailClick() {
//     navigate("/em/mass-email");
//   }

//   function handleEmailHistoryClick() {
//     navigate("/em/email-history");
//   }

//   // Helper function to calculate YUVA onboarding completion percentage
//   const getYuvaOnboardingCompletion = () => {
//     const total = all_institutes;
//     if (total === 0) return 0;
//     const completed = all_institutes_onboarding_onboarded;
//     return Math.round((completed / total) * 100);
//   };

//   // Helper function to calculate Thalir onboarding completion percentage
//   const getThalirOnboardingCompletion = () => {
//     const total = all_school_counts;
//     if (total === 0) return 0;
//     const completed = all_thalir_onboarding_onboarded;
//     return Math.round((completed / total) * 100);
//   };

//   // Helper function to get YUVA T&C status
//   const getYuvaTcStatus = () => {
//     const total = all_institutes;
//     if (total === 0) return { status: "No Data", percentage: 0, color: "#9e9e9e" };
//     const accepted = all_yuva_terms_counts;
//     const percentage = Math.round((accepted / total) * 100);

//     if (percentage >= 80) {
//       return { status: "Good", percentage, color: green[600] };
//     } else if (percentage >= 50) {
//       return { status: "Moderate", percentage, color: orange[600] };
//     } else {
//       return { status: "Low", percentage, color: red[600] };
//     }
//   };

//   // Helper function to get Thalir T&C status
//   const getThalirTcStatus = () => {
//     const total = all_school_counts;
//     if (total === 0) return { status: "No Data", percentage: 0, color: "#9e9e9e" };
//     const accepted = all_thalir_terms_counts;
//     const percentage = Math.round((accepted / total) * 100);

//     if (percentage >= 80) {
//       return { status: "Good", percentage, color: green[600] };
//     } else if (percentage >= 50) {
//       return { status: "Moderate", percentage, color: orange[600] };
//     } else {
//       return { status: "Low", percentage, color: red[600] };
//     }
//   };

//   const renderOverviewTab = () => (
//     <div>
//       {/* Data Overview Section */}
//       <h5
//         style={{
//           fontWeight: 600,
//           marginTop: 10,
//           marginBottom: 15,
//           color: "#2f80ed",
//           display: "flex",
//           alignItems: "center",
//           gap: "8px",
//         }}
//       >
//         <DashboardIcon style={{ fontSize: 20 }} />
//         Data Overview
//       </h5>

//       <Row>
//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("institutes", 0)}
//             onMouseEnter={() => setHoveredCard("institutes")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <DomainIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color: hoveredCard === "institutes" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("institutes", "title")}
//                 >
//                   Colleges/Schools
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-around",
//                   margin: "10px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("institutes", "count")}
//                   >
//                     {all_institutes}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Colleges
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("institutes", "count")}
//                   >
//                     {all_school_counts}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Schools
//                   </Typography>
//                 </div>
//               </div>
//               <div
//                 style={{
//                   marginTop: "12px",
//                   display: "flex",
//                   justifyContent: "space-between",
//                   gap: "12px",
//                 }}
//               >
//                 <Typography
//                   variant="body2"
//                   color="primary"
//                   style={{
//                     marginTop: "5px",
//                     cursor: "pointer",
//                     fontWeight: hoveredCard === "institutes" ? 600 : 500,
//                     color: hoveredCard === "institutes" ? "#1d4ed8" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                   onClick={() => navigate(`/em/institute/all?tab=institute`)}
//                 >
//                   View Colleges →
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   color="primary"
//                   style={{
//                     marginTop: "5px",
//                     cursor: "pointer",
//                     fontWeight: hoveredCard === "institutes" ? 600 : 500,
//                     color: hoveredCard === "institutes" ? "#1d4ed8" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                   onClick={() => navigate(`/em/institute/all?tab=thalir`)}
//                 >
//                   View Schools →
//                 </Typography>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>

//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("terms", 1)}
//             onMouseEnter={() => setHoveredCard("terms")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <GavelIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color: hoveredCard === "terms" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("terms", "title")}
//                 >
//                   Terms & Conditions
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-around",
//                   margin: "10px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("terms", "count")}
//                   >
//                     {all_yuva_terms_counts}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     YUVA
//                   </Typography>
//                 </div>

//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("terms", "count")}
//                   >
//                     {all_thalir_terms_counts}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Thalir
//                   </Typography>
//                 </div>
//               </div>
//               {/* Onboarding Completion Percentage */}
//               <div style={{ marginTop: "10px", textAlign: "center" }}>
//                 <Typography
//                   variant="h6"
//                   style={{
//                     color: getYuvaOnboardingCompletion() >= 80 ? green[600] : getYuvaOnboardingCompletion() >= 50 ? orange[600] : red[600],
//                     fontWeight: 700,
//                   }}
//                 >
//                   {getYuvaOnboardingCompletion()}% Complete
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   YUVA Onboarding Progress
//                 </Typography>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>

//         {/* T&C Status Card */}
//         <Col md={3} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("tcStatus", 4)}
//             onMouseEnter={() => setHoveredCard("tcStatus")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <GavelIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color: hoveredCard === "tcStatus" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("tcStatus", "title")}
//                 >
//                   T&C Status
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-around",
//                   margin: "10px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Chip
//                     label={getYuvaTcStatus().status}
//                     size="small"
//                     style={{
//                       backgroundColor: getYuvaTcStatus().color + "20",
//                       color: getYuvaTcStatus().color,
//                       fontWeight: 600,
//                     }}
//                   />
//                   <Typography variant="body2" color="text.secondary" style={{ marginTop: "4px" }}>
//                     YUVA: {getYuvaTcStatus().percentage}%
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Chip
//                     label={getThalirTcStatus().status}
//                     size="small"
//                     style={{
//                       backgroundColor: getThalirTcStatus().color + "20",
//                       color: getThalirTcStatus().color,
//                       fontWeight: 600,
//                     }}
//                   />
//                   <Typography variant="body2" color="text.secondary" style={{ marginTop: "4px" }}>
//                     Thalir: {getThalirTcStatus().percentage}%
//                   </Typography>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>
//       </Row>

//       {/* Additional Status Cards Row */}
//       <Row style={{ marginTop: "20px" }}>
//         <Col md={6} sm={12} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("tcStatus", 4)}
//             onMouseEnter={() => setHoveredCard("tcStatus")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <GavelIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color: hoveredCard === "tcStatus" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("tcStatus", "title")}
//                 >
//                   T&C Acceptance Status
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-around",
//                   margin: "15px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Chip
//                     label={getYuvaTcStatus().status}
//                     style={{
//                       backgroundColor: getYuvaTcStatus().color + "20",
//                       color: getYuvaTcStatus().color,
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                       padding: "6px 12px",
//                     }}
//                   />
//                   <Typography variant="body2" color="text.secondary" style={{ marginTop: "8px" }}>
//                     YUVA: {all_yuva_terms_counts}/{all_institutes} ({getYuvaTcStatus().percentage}%)
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Chip
//                     label={getThalirTcStatus().status}
//                     style={{
//                       backgroundColor: getThalirTcStatus().color + "20",
//                       color: getThalirTcStatus().color,
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                       padding: "6px 12px",
//                     }}
//                   />
//                   <Typography variant="body2" color="text.secondary" style={{ marginTop: "8px" }}>
//                     Thalir: {all_thalir_terms_counts}/{all_school_counts} ({getThalirTcStatus().percentage}%)
//                   </Typography>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>
//       </Row>
//       <Row>

//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("onboarding", 3)}
//             onMouseEnter={() => setHoveredCard("onboarding")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <PeopleIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color: hoveredCard === "onboarding" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("onboarding", "title")}
//                 >
//                   Onboarding Status
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   margin: "10px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("onboarding", "count")}
//                   >
//                     {all_institutes_onboarding_onboarded}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Onboarded
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("onboarding", "count")}
//                   >
//                     {all_institutes_onboarding_invited}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Invited
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("onboarding", "count")}
//                   >
//                     {all_institutes_onboarding_pending}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Pending
//                   </Typography>
//                 </div>
//               </div>
//               {/* Overall Onboarding Completion Percentage */}
//               <div style={{ marginTop: "10px", textAlign: "center" }}>
//                 <Typography
//                   variant="h6"
//                   style={{
//                     color: getYuvaOnboardingCompletion() >= 80 ? green[600] : getYuvaOnboardingCompletion() >= 50 ? orange[600] : red[600],
//                     fontWeight: 700,
//                   }}
//                 >
//                   {getYuvaOnboardingCompletion()}% Complete
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   Overall Onboarding Progress
//                 </Typography>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>
//       </Row>

//       {/* Additional Status Cards Row */}
//       <Row style={{ marginTop: "20px" }}>
//         <Col md={6} sm={12} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("tcStatus", 4)}
//             onMouseEnter={() => setHoveredCard("tcStatus")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <GavelIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color: hoveredCard === "tcStatus" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("tcStatus", "title")}
//                 >
//                   T&C Acceptance Status
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-around",
//                   margin: "15px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Chip
//                     label={getYuvaTcStatus().status}
//                     style={{
//                       backgroundColor: getYuvaTcStatus().color + "20",
//                       color: getYuvaTcStatus().color,
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                       padding: "6px 12px",
//                     }}
//                   />
//                   <Typography variant="body2" color="text.secondary" style={{ marginTop: "8px" }}>
//                     YUVA: {all_yuva_terms_counts}/{all_institutes} ({getYuvaTcStatus().percentage}%)
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Chip
//                     label={getThalirTcStatus().status}
//                     style={{
//                       backgroundColor: getThalirTcStatus().color + "20",
//                       color: getThalirTcStatus().color,
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                       padding: "6px 12px",
//                     }}
//                   />
//                   <Typography variant="body2" color="text.secondary" style={{ marginTop: "8px" }}>
//                     Thalir: {all_thalir_terms_counts}/{all_school_counts} ({getThalirTcStatus().percentage}%)
//                   </Typography>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );

//   const renderYUVATab = () => (
//     <div>
//       <h5
//         style={{
//           fontWeight: 600,
//           marginTop: 10,
//           marginBottom: 15,
//           color: "#2f80ed",
//           display: "flex",
//           alignItems: "center",
//           gap: "8px",
//         }}
//       >
//         <AccountBalanceIcon style={{ fontSize: 20 }} />
//         YUVA Module Overview
//       </h5>

//       <Row>
//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("yuvaInstitutes", 4)}
//             onMouseEnter={() => setHoveredCard("yuvaInstitutes")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <DomainIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color:
//                       hoveredCard === "yuvaInstitutes" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("yuvaInstitutes", "title")}
//                 >
//                   YUVA Colleges
//                 </Typography>
//               </div>
//               <Typography
//                 variant="h4"
//                 style={{
//                   margin: "10px 0",
//                   ...getFontStyle("yuvaInstitutes", "count"),
//                 }}
//               >
//                 {all_institutes}
//               </Typography>
//               <Typography
//                 variant="body2"
//                 color="primary"
//                 style={{
//                   marginTop: "5px",
//                   cursor: "pointer",
//                   fontWeight: hoveredCard === "yuvaInstitutes" ? 600 : 500,
//                   color:
//                     hoveredCard === "yuvaInstitutes" ? "#1d4ed8" : "#2f80ed",
//                   transition: "all 0.3s ease",
//                 }}
//                 onClick={() => navigate(`/em/institute/all?tab=institute`)}
//               >
//                 View details →
//               </Typography>
//             </CardContent>
//           </Card>
//         </Col>

//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("yuvaTerms", 5)}
//             onMouseEnter={() => setHoveredCard("yuvaTerms")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <GavelIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color: hoveredCard === "yuvaTerms" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("yuvaTerms", "title")}
//                 >
//                   YUVA Students
//                 </Typography>
//               </div>
//               <Typography
//                 variant="h4"
//                 style={{
//                   margin: "10px 0",
//                   ...getFontStyle("yuvaTerms", "count"),
//                 }}
//               >
//                 {all_institutesStudents}
//               </Typography>
//               {/* <Typography
//                 variant="body2"
//                 color="primary"
//                 style={{
//                   marginTop: "5px",
//                   cursor: "pointer",
//                   fontWeight: hoveredCard === "yuvaTerms" ? 600 : 500,
//                   color: hoveredCard === "yuvaTerms" ? "#1d4ed8" : "#2f80ed",
//                   transition: "all 0.3s ease",
//                 }}
//                 onClick={() =>
//                   navigate(`/em/institute/all?tab=institute&termsAccepted=true`)
//                 }
//               >
//                 View details →
//               </Typography> */}
//             </CardContent>
//           </Card>
//         </Col>

//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("yuvaOnboarding", 6)}
//             onMouseEnter={() => setHoveredCard("yuvaOnboarding")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <PeopleIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color:
//                       hoveredCard === "yuvaOnboarding" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("yuvaOnboarding", "title")}
//                 >
//                   YUVA Onboarding
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   margin: "10px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("yuvaOnboarding", "count")}
//                   >
//                     {all_institutes_onboarding_onboarded}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Onboarded
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("yuvaOnboarding", "count")}
//                   >
//                     {all_institutes_onboarding_invited}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Invited
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("yuvaOnboarding", "count")}
//                   >
//                     {all_institutes_onboarding_pending}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Pending
//                   </Typography>
//                 </div>
//               </div>
//               {/* YUVA Onboarding Completion Percentage */}
//               <div style={{ marginTop: "10px", textAlign: "center" }}>
//                 <Typography
//                   variant="h6"
//                   style={{
//                     color: getYuvaOnboardingCompletion() >= 80 ? green[600] : getYuvaOnboardingCompletion() >= 50 ? orange[600] : red[600],
//                     fontWeight: 700,
//                   }}
//                 >
//                   {getYuvaOnboardingCompletion()}% Complete
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   YUVA Onboarding Progress
//                 </Typography>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>
//       </Row>

//       {/* YUVA Management Section */}
//       <h5
//         style={{
//           fontWeight: 600,
//           marginTop: 25,
//           marginBottom: 15,
//           color: "#2f80ed",
//           display: "flex",
//           alignItems: "center",
//           gap: "8px",
//         }}
//       >
//         <ManageAccountsIcon style={{ fontSize: 20 }} />
//         YUVA Management
//       </h5>

//       <Row>
//         <Col md={6} sm={12} className="mb-4">
//           <Card
//             style={{
//               padding: "20px",
//               textAlign: "left",
//               borderRadius: "12px",
//               boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//               height: "100%",
//               border: "none",
//               backgroundColor: "white",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             <CardContent
//               style={{
//                 padding: "0",
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <DomainIcon fontSize="small" style={{ color: "#2f80ed" }} />
//                 <Typography
//                   variant="subtitle1"
//                   fontWeight={600}
//                   style={{ color: "#2c3e50" }}
//                 >
//                   Manage Colleges
//                 </Typography>
//               </div>
//               <Typography
//                 variant="body2"
//                 style={{
//                   marginBottom: "20px",
//                   color: "#7f8c8d",
//                   fontSize: "14px",
//                   lineHeight: "1.4",
//                   flex: 1,
//                 }}
//               >
//                 Manage YUVA institutes, view details, and track onboarding
//                 status for colleges and universities in your chapter.
//               </Typography>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginTop: "auto",
//                 }}
//               >
//                 <button
//                   style={{
//                     padding: "8px 20px",
//                     borderRadius: "6px",
//                     border: "1px solid #2f80ed",
//                     backgroundColor: "transparent",
//                     color: "#2f80ed",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                     transition: "all 0.2s ease",
//                     minWidth: "140px",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = "#2f80ed";
//                     e.target.style.color = "white";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = "transparent";
//                     e.target.style.color = "#2f80ed";
//                   }}
//                   onClick={() => navigate(`/em/institute/all?tab=institute`)}
//                 >
//                   Manage Colleges
//                 </button>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>

//         <Col md={6} sm={12} className="mb-4">
//           <Card
//             style={{
//               padding: "20px",
//               textAlign: "left",
//               borderRadius: "12px",
//               boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//               height: "100%",
//               border: "none",
//               backgroundColor: "white",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             <CardContent
//               style={{
//                 padding: "0",
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <GavelIcon fontSize="small" style={{ color: "#e74c3c" }} />
//                 <Typography
//                   variant="subtitle1"
//                   fontWeight={600}
//                   style={{ color: "#2c3e50" }}
//                 >
//                   Terms & Conditions
//                 </Typography>
//               </div>
//               <Typography
//                 variant="body2"
//                 style={{
//                   marginBottom: "20px",
//                   color: "#7f8c8d",
//                   fontSize: "14px",
//                   lineHeight: "1.4",
//                   flex: 1,
//                 }}
//               >
//                 Track YUVA institutes that have accepted terms and conditions.
//                 Monitor compliance and follow up with pending institutes.
//               </Typography>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginTop: "auto",
//                 }}
//               >
//                 <button
//                   style={{
//                     padding: "8px 20px",
//                     borderRadius: "6px",
//                     border: "1px solid #e74c3c",
//                     backgroundColor: "transparent",
//                     color: "#e74c3c",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                     transition: "all 0.2s ease",
//                     minWidth: "140px",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = "#e74c3c";
//                     e.target.style.color = "white";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = "transparent";
//                     e.target.style.color = "#e74c3c";
//                   }}
//                   onClick={() =>
//                     navigate(
//                       `/em/institute/all?tab=institute&termsAccepted=true`
//                     )
//                   }
//                 >
//                   View Terms Status
//                 </button>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );

//   const renderThalirTab = () => (
//     <div>
//       <h5
//         style={{
//           fontWeight: 600,
//           marginTop: 10,
//           marginBottom: 15,
//           color: "#2f80ed",
//           display: "flex",
//           alignItems: "center",
//           gap: "8px",
//         }}
//       >
//         <SchoolIcon style={{ fontSize: 20 }} />
//         Thalir Module Overview
//       </h5>

//       <Row>
//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("thalirSchools", 7)}
//             onMouseEnter={() => setHoveredCard("thalirSchools")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <SchoolIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color:
//                       hoveredCard === "thalirSchools" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("thalirSchools", "title")}
//                 >
//                   Thalir Schools
//                 </Typography>
//               </div>
//               <Typography
//                 variant="h4"
//                 style={{
//                   margin: "10px 0",
//                   ...getFontStyle("thalirSchools", "count"),
//                 }}
//               >
//                 {all_school_counts}
//               </Typography>
//               <Typography
//                 variant="body2"
//                 color="primary"
//                 style={{
//                   marginTop: "5px",
//                   cursor: "pointer",
//                   fontWeight: hoveredCard === "institutes" ? 600 : 500,
//                   color: hoveredCard === "institutes" ? "#1d4ed8" : "#2f80ed",
//                   transition: "all 0.3s ease",
//                 }}
//                 onClick={() => navigate(`/em/institute/all?tab=thalir`)}
//               >
//                 View Schools →
//               </Typography>
//             </CardContent>
//           </Card>
//         </Col>

//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("thalirTerms", 8)}
//             onMouseEnter={() => setHoveredCard("thalirTerms")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <GavelIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color:
//                       hoveredCard === "thalirTerms" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("thalirTerms", "title")}
//                 >
//                   Thalir Students
//                 </Typography>
//               </div>
//               <Typography
//                 variant="h4"
//                 style={{
//                   margin: "10px 0",
//                   ...getFontStyle("thalirTerms", "count"),
//                 }}
//               >
//                 {all_schoolStudents_counts}
//               </Typography>
//               {/* <Typography
//                 variant="body2"
//                 color="primary"
//                 style={{
//                   marginTop: "5px",
//                   cursor: "pointer",
//                   fontWeight: hoveredCard === "thalirTerms" ? 600 : 500,
//                   color: hoveredCard === "thalirTerms" ? "#1d4ed8" : "#2f80ed",
//                   transition: "all 0.3s ease",
//                 }}
//                 onClick={() =>
//                   navigate(`/em/institute/all?tab=thalir&termsAccepted=true`)
//                 }
//               >
//                 View details →
//               </Typography> */}
//             </CardContent>
//           </Card>
//         </Col>

//         {/* <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("thalirEmail", 9)}
//             onMouseEnter={() => setHoveredCard("thalirEmail")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <MarkEmailReadIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color:
//                       hoveredCard === "thalirEmail" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("thalirEmail", "title")}
//                 >
//                   Thalir Email Status
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-around",
//                   margin: "10px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("thalirEmail", "count")}
//                   >
//                     {all_institutes_email_sent}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Sent
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("thalirEmail", "count")}
//                   >
//                     {all_institutes_email_not_sent}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Not Sent
//                   </Typography>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>
//         </Col> */}
//         <Col md={4} sm={6} xs={12}>
//           <Card
//             className={css.serviceCountCard}
//             style={getCardStyle("yuvaOnboarding", 6)}
//             onMouseEnter={() => setHoveredCard("yuvaOnboarding")}
//             onMouseLeave={() => setHoveredCard(null)}
//           >
//             <CardContent>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <PeopleIcon
//                   fontSize="small"
//                   style={{
//                     fontSize: 20,
//                     color:
//                       hoveredCard === "yuvaOnboarding" ? "#1e40af" : "#2f80ed",
//                     transition: "all 0.3s ease",
//                   }}
//                 />
//                 <Typography
//                   variant="subtitle2"
//                   style={getFontStyle("yuvaOnboarding", "title")}
//                 >
//                   Thalir Onboarding
//                 </Typography>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   margin: "10px 0",
//                 }}
//               >
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("yuvaOnboarding", "count")}
//                   >
//                     {all_thalir_onboarding_onboarded}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Onboarded
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("yuvaOnboarding", "count")}
//                   >
//                     {all_thalir_onboarding_invited}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Invited
//                   </Typography>
//                 </div>
//                 <div style={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h4"
//                     style={getFontStyle("yuvaOnboarding", "count")}
//                   >
//                     {all_thalir_onboarding_pending}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Pending
//                   </Typography>
//                 </div>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>
//       </Row>

//       {/* Thalir Management Section */}
//       <h5
//         style={{
//           fontWeight: 600,
//           marginTop: 25,
//           marginBottom: 15,
//           color: "#2f80ed",
//           display: "flex",
//           alignItems: "center",
//           gap: "8px",
//         }}
//       >
//         <ManageAccountsIcon style={{ fontSize: 20 }} />
//         Thalir Management
//       </h5>

//       <Row>
//         <Col md={6} sm={12} className="mb-4">
//           <Card
//             style={{
//               padding: "20px",
//               textAlign: "left",
//               borderRadius: "12px",
//               boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//               height: "100%",
//               border: "none",
//               backgroundColor: "white",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             <CardContent
//               style={{
//                 padding: "0",
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <SchoolIcon fontSize="small" style={{ color: "#2f80ed" }} />
//                 <Typography
//                   variant="subtitle1"
//                   fontWeight={600}
//                   style={{ color: "#2c3e50" }}
//                 >
//                   Manage Schools
//                 </Typography>
//               </div>
//               <Typography
//                 variant="body2"
//                 style={{
//                   marginBottom: "20px",
//                   color: "#7f8c8d",
//                   fontSize: "14px",
//                   lineHeight: "1.4",
//                   flex: 1,
//                 }}
//               >
//                 Manage Thalir schools, view details, and track onboarding status
//                 for schools in your chapter. Monitor student enrollment and
//                 engagement.
//               </Typography>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginTop: "auto",
//                 }}
//               >
//                 <button
//                   style={{
//                     padding: "8px 20px",
//                     borderRadius: "6px",
//                     border: "1px solid #2f80ed",
//                     backgroundColor: "transparent",
//                     color: "#2f80ed",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                     transition: "all 0.2s ease",
//                     minWidth: "140px",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = "#2f80ed";
//                     e.target.style.color = "white";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = "transparent";
//                     e.target.style.color = "#2f80ed";
//                   }}
//                   onClick={() => navigate(`/em/institute/all?tab=thalir`)}
//                 >
//                   Manage Schools
//                 </button>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>

//         <Col md={6} sm={12} className="mb-4">
//           <Card
//             style={{
//               padding: "20px",
//               textAlign: "left",
//               borderRadius: "12px",
//               boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//               height: "100%",
//               border: "none",
//               backgroundColor: "white",
//               display: "flex",
//               flexDirection: "column",
//             }}
//           >
//             <CardContent
//               style={{
//                 padding: "0",
//                 flex: 1,
//                 display: "flex",
//                 flexDirection: "column",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <GavelIcon fontSize="small" style={{ color: "#e74c3c" }} />
//                 <Typography
//                   variant="subtitle1"
//                   fontWeight={600}
//                   style={{ color: "#2c3e50" }}
//                 >
//                   Terms & Conditions
//                 </Typography>
//               </div>
//               <Typography
//                 variant="body2"
//                 style={{
//                   marginBottom: "20px",
//                   color: "#7f8c8d",
//                   fontSize: "14px",
//                   lineHeight: "1.4",
//                   flex: 1,
//                 }}
//               >
//                 Track Thalir schools that have accepted terms and conditions.
//                 Monitor compliance and follow up with pending schools for
//                 agreement completion.
//               </Typography>
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginTop: "auto",
//                 }}
//               >
//                 <button
//                   style={{
//                     padding: "8px 20px",
//                     borderRadius: "6px",
//                     border: "1px solid #e74c3c",
//                     backgroundColor: "transparent",
//                     color: "#e74c3c",
//                     fontWeight: "500",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                     transition: "all 0.2s ease",
//                     minWidth: "140px",
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.backgroundColor = "#e74c3c";
//                     e.target.style.color = "white";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.backgroundColor = "transparent";
//                     e.target.style.color = "#e74c3c";
//                   }}
//                   onClick={() =>
//                     navigate(`/em/institute/all?tab=thalir&termsAccepted=true`)
//                   }
//                 >
//                   View Terms Status
//                 </button>
//               </div>
//             </CardContent>
//           </Card>
//         </Col>
//       </Row>
//     </div>
//   );

//   const renderQuickNavigation = () => (
//     <div>
//       {/* Quick Navigation Section - Only show in Overview tab */}
//       {activeTab === "overview" && (
//         <>
//           <h5
//             style={{
//               fontWeight: 600,
//               marginTop: 25,
//               marginBottom: 15,
//               color: "#2f80ed",
//               display: "flex",
//               alignItems: "center",
//               gap: "8px",
//             }}
//           >
//             <NavigationIcon style={{ fontSize: 20 }} />
//             Quick Navigation
//           </h5>

//           <Row>
//             {/* <Col md={4} sm={6} xs={12} className="mb-4">
//               <Card
//                 style={{
//                   padding: "20px",
//                   textAlign: "left",
//                   borderRadius: "12px",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//                   height: "100%",
//                   border: "none",
//                   backgroundColor: "white",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <CardContent
//                   style={{
//                     padding: "0",
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                       marginBottom: "12px",
//                     }}
//                   >
//                     <DomainIcon fontSize="small" style={{ color: "#2f80ed" }} />
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       style={{ color: "#2c3e50" }}
//                     >
//                       Manage Institutes
//                     </Typography>
//                   </div>
//                   <Typography
//                     variant="body2"
//                     style={{
//                       marginBottom: "20px",
//                       color: "#7f8c8d",
//                       fontSize: "14px",
//                       lineHeight: "1.4",
//                       flex: 1,
//                     }}
//                   >
//                     You can manage the Institutes on the portal by clicking on
//                     below button
//                   </Typography>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginTop: "auto",
//                     }}
//                   >
//                     <button
//                       style={{
//                         padding: "8px 20px",
//                         borderRadius: "6px",
//                         border: "1px solid #2f80ed",
//                         backgroundColor: "transparent",
//                         color: "#2f80ed",
//                         fontWeight: "500",
//                         cursor: "pointer",
//                         fontSize: "14px",
//                         transition: "all 0.2s ease",
//                         minWidth: "120px",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor = "#2f80ed";
//                         e.target.style.color = "white";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor = "transparent";
//                         e.target.style.color = "#2f80ed";
//                       }}
//                       onClick={handleInstitutesClick}
//                     >
//                       Manage Institutes
//                     </button>
//                   </div>
//                 </CardContent>
//               </Card>
//             </Col> */}

//             <Col md={6} sm={6} xs={12} className="mb-4">
//               <Card
//                 style={{
//                   padding: "20px",
//                   textAlign: "left",
//                   borderRadius: "12px",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//                   height: "100%",
//                   border: "none",
//                   backgroundColor: "white",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <CardContent
//                   style={{
//                     padding: "0",
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                       marginBottom: "12px",
//                     }}
//                   >
//                     <MarkEmailReadIcon
//                       fontSize="small"
//                       style={{ color: "#e74c3c" }}
//                     />
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       style={{ color: "#2c3e50" }}
//                     >
//                       Mass Email Communication
//                     </Typography>
//                   </div>
//                   <Typography
//                     variant="body2"
//                     style={{
//                       marginBottom: "20px",
//                       color: "text.secondary",
//                       fontSize: "14px",
//                       lineHeight: "1.4",
//                       flex: 1,
//                     }}
//                   >
//                     Send targeted emails to students and institutes in your
//                     region and city. Enhance communication efficiency with
//                     filtered email campaigns.
//                   </Typography>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginTop: "auto",
//                     }}
//                   >
//                     <button
//                       style={{
//                         padding: "8px 20px",
//                         borderRadius: "6px",
//                         border: "1px solid #e74c3c",
//                         backgroundColor: "transparent",
//                         color: "#e74c3c",
//                         fontWeight: "500",
//                         cursor: "pointer",
//                         fontSize: "14px",
//                         transition: "all 0.2s ease",
//                         minWidth: "120px",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor = "#e74c3c";
//                         e.target.style.color = "white";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor = "transparent";
//                         e.target.style.color = "#e74c3c";
//                       }}
//                       onClick={handleMassEmailClick}
//                     >
//                       Manage Mass Email
//                     </button>
//                   </div>
//                 </CardContent>
//               </Card>
//             </Col>

//             <Col md={6} sm={6} xs={12} className="mb-4">
//               <Card
//                 style={{
//                   padding: "20px",
//                   textAlign: "left",
//                   borderRadius: "12px",
//                   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//                   height: "100%",
//                   border: "none",
//                   backgroundColor: "white",
//                   display: "flex",
//                   flexDirection: "column",
//                 }}
//               >
//                 <CardContent
//                   style={{
//                     padding: "0",
//                     flex: 1,
//                     display: "flex",
//                     flexDirection: "column",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                       marginBottom: "12px",
//                     }}
//                   >
//                     <HistoryIcon
//                       fontSize="small"
//                       style={{ color: "#9b59b6" }}
//                     />
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       style={{ color: "#2c3e50" }}
//                     >
//                       Email History
//                     </Typography>
//                   </div>
//                   <Typography
//                     variant="body2"
//                     style={{
//                       marginBottom: "20px",
//                       color: "text.secondary",
//                       fontSize: "14px",
//                       lineHeight: "1.4",
//                       flex: 1,
//                     }}
//                   >
//                     View and track all emails you've sent through the mass email
//                     system. Monitor delivery status and recipient engagement.
//                   </Typography>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       marginTop: "auto",
//                     }}
//                   >
//                     <button
//                       style={{
//                         padding: "8px 20px",
//                         borderRadius: "6px",
//                         border: "1px solid #9b59b6",
//                         backgroundColor: "transparent",
//                         color: "#9b59b6",
//                         fontWeight: "500",
//                         cursor: "pointer",
//                         fontSize: "14px",
//                         transition: "all 0.2s ease",
//                         minWidth: "120px",
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.backgroundColor = "#9b59b6";
//                         e.target.style.color = "white";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.backgroundColor = "transparent";
//                         e.target.style.color = "#9b59b6";
//                       }}
//                       onClick={handleEmailHistoryClick}
//                     >
//                       View Email History
//                     </button>
//                   </div>
//                 </CardContent>
//               </Card>
//             </Col>
//           </Row>
//         </>
//       )}
//     </div>
//   );

//   return isLoading ? (
//     <Loader />
//   ) : (
//     <div className={css.outerDiv}>
//       {/* <HeaderCard>
//         <h1 className="headerTitle">Chapter EM Dashboard</h1>
//         <hr />
//         <p className="headerSubtitle">
//           Manage institutes, track performance metrics, and communicate
//           effectively with your chapter.
//         </p>
//       </HeaderCard> */}

//       {/* Tab Navigation */}
//       <div className="my-4">
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             backgroundColor: "#f9fbfd",
//             borderRadius: 8,
//             marginBottom: "20px",
//           }}
//         >
//           <Tabs
//             value={activeTab}
//             onChange={(e, v) => setActiveTab(v)}
//             textColor="primary"
//             TabIndicatorProps={{ style: { display: "none" } }}
//             sx={{
//               backgroundColor: "#f2f4f7",
//               borderRadius: "8px",
//               padding: "6px",
//               "& .MuiTab-root": {
//                 textTransform: "none",
//                 fontWeight: 500,
//                 minHeight: 40,
//                 borderRadius: "8px",
//                 marginX: "8px",
//                 padding: "6px 16px",
//                 marginRight: 1,
//                 color: "#4f4f4f",
//                 "& .MuiSvgIcon-root": {
//                   color: "#4f4f4f",
//                 },
//               },
//               "& .Mui-selected": {
//                 backgroundColor: "#2f80ed",
//                 color: "#fff",
//                 "& .MuiSvgIcon-root": {
//                   color: "#fff",
//                 },
//               },
//             }}
//           >
//             <Tab
//               value="overview"
//               icon={<DataUsageIcon fontSize="small" />}
//               label="Overview"
//               iconPosition="start"
//             />
//             <Tab
//               value="yuva"
//               icon={<AccountBalanceIcon fontSize="small" />}
//               label="YUVA"
//               iconPosition="start"
//             />
//             <Tab
//               value="thalir"
//               icon={<SchoolIcon fontSize="small" />}
//               label="Thalir"
//               iconPosition="start"
//             />
//           </Tabs>
//         </div>

//         {/* Conditional Rendering for Tabs */}
//         {activeTab === "overview" && renderOverviewTab()}
//         {activeTab === "yuva" && renderYUVATab()}
//         {activeTab === "thalir" && renderThalirTab()}

//         {/* Quick Navigation - Show only in Overview tab */}
//         {renderQuickNavigation()}
//       </div>
//     </div>
//   );
// };

// export default EMServicePage;









import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { toast } from "react-hot-toast";

// Icons
import DataUsageIcon from "@mui/icons-material/DataUsage";
import SchoolIcon from "@mui/icons-material/School";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DashboardIcon from "@mui/icons-material/Dashboard";
import NavigationIcon from "@mui/icons-material/Navigation";
import BuildIcon from "@mui/icons-material/Build";
import DomainIcon from "@mui/icons-material/Domain";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import HistoryIcon from "@mui/icons-material/History";
import PeopleIcon from "@mui/icons-material/People";
import GavelIcon from "@mui/icons-material/Gavel";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

// My components
import HeaderCard from "../../components/common/HeaderCard";

// My css
import css from "../../css/admin/home-page.module.css";

import { SERVER_ORIGIN } from "../../utilities/constants";
import Loader from "../../components/common/Loader";
import { useUserType } from "../common/UserTypeContext";

const EMServicePage = () => {
  const { setUserTypeToChapterEM } = useUserType();
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [hoveredCard, setHoveredCard] = useState(null);

  // State for dynamic data
  const [all_institutes, setAll_institutes] = useState(0);
  const [all_school_counts, setall_school_counts] = useState(0);
  const [all_yuva_terms_counts, setall_yuva_counts_counts] = useState(0);
  const [all_thalir_terms_counts, setall_thalir_terms_counts] = useState(0);
  const [all_mou_accepted, setAll_mou_accepted] = useState(0);
  const [all_mou_rejected, setAll_mou_rejected] = useState(0);
  const [all_mou_pending, setAll_mou_pending] = useState(0);
  const [
    all_institutes_onboarding_onboarded,
    setAll_institutes_onboarding_onboarded,
  ] = useState(0);
  const [
    all_institutes_onboarding_invited,
    setAll_institutes_onboarding_invited,
  ] = useState(0);
  const [
    all_institutes_onboarding_pending,
    setAll_institutes_onboarding_pending,
  ] = useState(0);

  const [all_thalir_onboarding_onboarded, setAll_thalir_onboarding_onboarded] =
    useState(0);
  const [all_thalir_onboarding_invited, setAll_thalir_onboarding_invited] =
    useState(0);
  const [all_thalir_onboarding_pending, setAll_thalir_onboarding_pending] =
    useState(0);
  const [all_institutes_email_sent, setAll_institutes_email_sent] = useState(0);
  const [all_institutes_email_not_sent, setAll_institutes_email_not_sent] =
    useState(0);
  const [isMouSigned, setIsMouSigned] = useState(false);
  const [all_institutesStudents, setAll_institutesStudets] = useState(0);
  const [all_schoolStudents_counts, setall_schoolStudents_counts] = useState(0);
  const navigate = useNavigate();

  // Function to get font styles based on hover state
  const getFontStyle = (cardType, type = "title") => {
    const isHovered = hoveredCard === cardType;

    switch (type) {
      case "title":
        return {
          fontWeight: isHovered ? 700 : 600,
          fontSize: isHovered ? "1.1rem" : "1rem",
          color: isHovered ? "#1a56db" : "#2c3e50",
          transition: "all 0.3s ease",
        };
      case "count":
        return {
          fontWeight: isHovered ? 800 : 700,
          fontSize: isHovered ? "2.5rem" : "2.25rem",
          color: isHovered ? "#1e40af" : "#2f80ed",
          transition: "all 0.3s ease",
        };
      case "description":
        return {
          fontWeight: isHovered ? 500 : 400,
          color: isHovered ? "#4b5563" : "#7f8c8d",
          transition: "all 0.3s ease",
        };
      default:
        return {};
    }
  };

  // Function to get card style with hover effect
  const getCardStyle = (cardType, index) => {
    const isHovered = hoveredCard === cardType;
    return {
      padding: "15px",
      textAlign: "left",
      borderRadius: "12px",
      boxShadow: isHovered
        ? "0 8px 20px rgba(0,0,0,0.12)"
        : "0 4px 12px rgba(0,0,0,0.08)",
      height: "100%",
      border: "none",
      backgroundColor: "white",
      transition: "all 0.3s ease",
      transform: isHovered ? "translateY(-4px)" : "none",
      cursor: "pointer",
    };
  };

  // Function to fetch count data from API
  const fetchCountData = async () => {
    const em_id = sessionStorage.getItem("_id");
    setIsLoading(true);
    try {
      const response = await fetch(`${SERVER_ORIGIN}/api/em/auth/counting`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        },
        body: JSON.stringify({ _id: em_id }),
      });

      const result = await response.json();

      if (response.status >= 400 && response.status < 600) {
        if (response.status === 401) {
          navigate("/login?userType=em");
        } else {
          toast.error("Failed to fetch data");
        }
      } else if (response.ok && response.status === 200) {
        // Set data from API response
        setAll_institutes(result.data.all_institutes || 0);
        setAll_mou_accepted(result.data.all_mou_accepted || 0);
        setAll_mou_rejected(result.data.all_mou_rejected || 0);
        setAll_mou_pending(result.data.all_mou_pending || 0);
        setall_school_counts(result.data.all_school_counts || 0);
        setAll_institutes_onboarding_pending(
          result.data.all_institutes_onboarding_pending || 0
        );
        setAll_institutes_onboarding_invited(
          result.data.all_institutes_onboarding_invited || 0
        );
        setAll_institutes_email_sent(
          result.data.all_institutes_email_sent || 0
        );
        setAll_institutes_onboarding_onboarded(
          result.data.all_institutes_onboarding_onboarded || 0
        );
        // set thalir
        setAll_thalir_onboarding_onboarded(
          result.data.all_thalir_onboarding_onboarded || 0
        );
        setAll_thalir_onboarding_pending(
          result.data.all_thalir_onboarding_pending || 0
        );
        setAll_thalir_onboarding_invited(
          result.data.all_thalir_onboarding_invited || 0
        );
        // end of thalir counts
        setAll_institutes_email_not_sent(
          result.data.all_institutes_email_not_sent || 0
        );
        setall_thalir_terms_counts(result.data.thalir_termsAccepted || 0);
        setall_yuva_counts_counts(result.data.yuva_termsAccepted || 0);

        setAll_institutesStudets(result.data.all_yuvastudents_counts || 0);
        setall_schoolStudents_counts(
          result.data.all_thalirstudents_counts || 0
        );
      }
    } catch (err) {
      console.error(err.message);
      toast.error("Failed to fetch data");
    }
    setIsLoading(false);
  };

  // Function to check MOU status
  const checkMou = async () => {
    try {
      const response = await fetch(`${SERVER_ORIGIN}/api/em/auth/check-mou`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        },
        body: JSON.stringify({ _id: sessionStorage.getItem("_id") }),
      });

      const result = await response.json();
      if (response.status >= 200 && response.status < 300) {
        setIsMouSigned(result.data.termsAccepted);
      } else {
        throw new Error("Failed to check MOU status");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Function to verify token
  const verifyToken = async () => {
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/em/auth/verify-token`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );

      const result = await response.json();

      if (response.status >= 400 && response.status < 600) {
        if (response.status === 401) {
          navigate("/login?userType=em");
        }
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    setUserTypeToChapterEM();
    verifyToken();
    fetchCountData();
    checkMou();
  }, [setUserTypeToChapterEM, navigate]);

  function handleInstitutesClick() {
    navigate("/em/institute/all");
  }

  function handleMassEmailClick() {
    navigate("/em/mass-email");
  }

  function handleEmailHistoryClick() {
    navigate("/em/email-history");
  }

  const renderOverviewTab = () => (
    <div>
      {/* Data Overview Section */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 10,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <DashboardIcon style={{ fontSize: 20 }} />
        Data Overview
      </h5>

      <Row>
        <Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("institutes", 0)}
            onMouseEnter={() => setHoveredCard("institutes")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <DomainIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "institutes" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("institutes", "title")}
                >
                  Colleges/Schools
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  margin: "10px 0",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("institutes", "count")}
                  >
                    {all_institutes}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Colleges
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("institutes", "count")}
                  >
                    {all_school_counts}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Schools
                  </Typography>
                </div>
              </div>
              <div
                style={{
                  marginTop: "12px",
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "12px",
                }}
              >
                <Typography
                  variant="body2"
                  color="primary"
                  style={{
                    marginTop: "5px",
                    cursor: "pointer",
                    fontWeight: hoveredCard === "institutes" ? 600 : 500,
                    color: hoveredCard === "institutes" ? "#1d4ed8" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                  onClick={() => navigate(`/em/institute/all?tab=institute`)}
                >
                  View Colleges →
                </Typography>
                <Typography
                  variant="body2"
                  color="primary"
                  style={{
                    marginTop: "5px",
                    cursor: "pointer",
                    fontWeight: hoveredCard === "institutes" ? 600 : 500,
                    color: hoveredCard === "institutes" ? "#1d4ed8" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                  onClick={() => navigate(`/em/institute/all?tab=thalir`)}
                >
                  View Schools →
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Col>

        <Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("terms", 1)}
            onMouseEnter={() => setHoveredCard("terms")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <GavelIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "terms" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("terms", "title")}
                >
                  Terms & Conditions
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  margin: "10px 0",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("terms", "count")}
                  >
                    {all_yuva_terms_counts}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    YUVA
                  </Typography>
                </div>

                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("terms", "count")}
                  >
                    {all_thalir_terms_counts}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Thalir
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Col>

        {/* <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("email", 2)}
            onMouseEnter={() => setHoveredCard("email")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <MarkEmailReadIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "email" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("email", "title")}
                >
                  Email Status
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  margin: "10px 0",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("email", "count")}
                  >
                    {all_institutes_email_sent}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Sent
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("email", "count")}
                  >
                    {all_institutes_email_not_sent}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Not Sent
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Col> */}

        <Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("onboarding", 3)}
            onMouseEnter={() => setHoveredCard("onboarding")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <PeopleIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "onboarding" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("onboarding", "title")}
                >
                  Onboarding Status
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "10px 0",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("onboarding", "count")}
                  >
                    {all_institutes_onboarding_onboarded}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Onboarded
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("onboarding", "count")}
                  >
                    {all_institutes_onboarding_invited}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Invited
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("onboarding", "count")}
                  >
                    {all_institutes_onboarding_pending}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Pending
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Col>
      </Row>
    </div>
  );

  const renderYUVATab = () => (
    <div>
      <h5
        style={{
          fontWeight: 600,
          marginTop: 10,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <AccountBalanceIcon style={{ fontSize: 20 }} />
        YUVA Module Overview
      </h5>

      <Row>
        <Col md={6} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("yuvaInstitutes", 4)}
            onMouseEnter={() => setHoveredCard("yuvaInstitutes")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <DomainIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color:
                      hoveredCard === "yuvaInstitutes" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("yuvaInstitutes", "title")}
                >
                  YUVA Colleges
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("yuvaInstitutes", "count"),
                }}
              >
                {all_institutes}
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "yuvaInstitutes" ? 600 : 500,
                  color:
                    hoveredCard === "yuvaInstitutes" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                onClick={() => navigate(`/em/institute/all?tab=institute`)}
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>

        {/* <Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("yuvaTerms", 5)}
            onMouseEnter={() => setHoveredCard("yuvaTerms")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <GavelIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "yuvaTerms" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("yuvaTerms", "title")}
                >
                  YUVA Students
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("yuvaTerms", "count"),
                }}
              >
                {all_institutesStudents}
              </Typography>
            
            </CardContent>
          </Card>
        </Col> */}

        <Col md={6} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("yuvaOnboarding", 6)}
            onMouseEnter={() => setHoveredCard("yuvaOnboarding")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <PeopleIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color:
                      hoveredCard === "yuvaOnboarding" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("yuvaOnboarding", "title")}
                >
                  YUVA Onboarding
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "10px 0",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("yuvaOnboarding", "count")}
                  >
                    {all_institutes_onboarding_onboarded}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Onboarded
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("yuvaOnboarding", "count")}
                  >
                    {all_institutes_onboarding_invited}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Invited
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("yuvaOnboarding", "count")}
                  >
                    {all_institutes_onboarding_pending}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Pending
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Col>
      </Row>

      {/* YUVA Management Section */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <ManageAccountsIcon style={{ fontSize: 20 }} />
        YUVA Management
      </h5>

      <Row>
        <Col md={6} sm={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <DomainIcon fontSize="small" style={{ color: "#2f80ed" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Manage Colleges
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                Manage YUVA institutes, view details, and track onboarding
                status for colleges and universities in your chapter.
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #2f80ed",
                    backgroundColor: "transparent",
                    color: "#2f80ed",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "140px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#2f80ed";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#2f80ed";
                  }}
                  onClick={() => navigate(`/em/institute/all?tab=institute`)}
                >
                  Manage Colleges
                </button>
              </div>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} sm={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <GavelIcon fontSize="small" style={{ color: "#e74c3c" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Terms & Conditions
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                Track YUVA institutes that have accepted terms and conditions.
                Monitor compliance and follow up with pending institutes.
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #e74c3c",
                    backgroundColor: "transparent",
                    color: "#e74c3c",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "140px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#e74c3c";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#e74c3c";
                  }}
                  onClick={() =>
                    navigate(
                      `/em/institute/all?tab=institute&termsAccepted=true`
                    )
                  }
                >
                  View Terms Status
                </button>
              </div>
            </CardContent>
          </Card>
        </Col>
      </Row>
    </div>
  );

  const renderThalirTab = () => (
    <div>
      <h5
        style={{
          fontWeight: 600,
          marginTop: 10,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <SchoolIcon style={{ fontSize: 20 }} />
        Thalir Module Overview
      </h5>

      <Row>
        <Col md={6} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("thalirSchools", 7)}
            onMouseEnter={() => setHoveredCard("thalirSchools")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <SchoolIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color:
                      hoveredCard === "thalirSchools" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("thalirSchools", "title")}
                >
                  Thalir Schools
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("thalirSchools", "count"),
                }}
              >
                {all_school_counts}
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "institutes" ? 600 : 500,
                  color: hoveredCard === "institutes" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                onClick={() => navigate(`/em/institute/all?tab=thalir`)}
              >
                View Schools →
              </Typography>
            </CardContent>
          </Card>
        </Col>

        {/* <Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("thalirTerms", 8)}
            onMouseEnter={() => setHoveredCard("thalirTerms")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <GavelIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color:
                      hoveredCard === "thalirTerms" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("thalirTerms", "title")}
                >
                  Thalir Students
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("thalirTerms", "count"),
                }}
              >
                {all_schoolStudents_counts}
              </Typography>
            </CardContent>
          </Card>
        </Col> */}

        <Col md={6} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("yuvaOnboarding", 6)}
            onMouseEnter={() => setHoveredCard("yuvaOnboarding")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <PeopleIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color:
                      hoveredCard === "yuvaOnboarding" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("yuvaOnboarding", "title")}
                >
                  Thalir Onboarding
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "10px 0",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("yuvaOnboarding", "count")}
                  >
                    {all_thalir_onboarding_onboarded}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Onboarded
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("yuvaOnboarding", "count")}
                  >
                    {all_thalir_onboarding_invited}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Invited
                  </Typography>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Typography
                    variant="h4"
                    style={getFontStyle("yuvaOnboarding", "count")}
                  >
                    {all_thalir_onboarding_pending}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Pending
                  </Typography>
                </div>
              </div>
            </CardContent>
          </Card>
        </Col>
      </Row>

      {/* Thalir Management Section */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <ManageAccountsIcon style={{ fontSize: 20 }} />
        Thalir Management
      </h5>

      <Row>
        <Col md={6} sm={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <SchoolIcon fontSize="small" style={{ color: "#2f80ed" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Manage Schools
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                Manage Thalir schools, view details, and track onboarding status
                for schools in your chapter. Monitor student enrollment and
                engagement.
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #2f80ed",
                    backgroundColor: "transparent",
                    color: "#2f80ed",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "140px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#2f80ed";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#2f80ed";
                  }}
                  onClick={() => navigate(`/em/institute/all?tab=thalir`)}
                >
                  Manage Schools
                </button>
              </div>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} sm={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <GavelIcon fontSize="small" style={{ color: "#e74c3c" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Terms & Conditions
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                Track Thalir schools that have accepted terms and conditions.
                Monitor compliance and follow up with pending schools for
                agreement completion.
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #e74c3c",
                    backgroundColor: "transparent",
                    color: "#e74c3c",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "140px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#e74c3c";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#e74c3c";
                  }}
                  onClick={() =>
                    navigate(`/em/institute/all?tab=thalir&termsAccepted=true`)
                  }
                >
                  View Terms Status
                </button>
              </div>
            </CardContent>
          </Card>
        </Col>
      </Row>
    </div>
  );

  const renderQuickNavigation = () => (
    <div>
      {/* Quick Navigation Section - Only show in Overview tab */}
      {activeTab === "overview" && (
        <>
          <h5
            style={{
              fontWeight: 600,
              marginTop: 25,
              marginBottom: 15,
              color: "#2f80ed",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <NavigationIcon style={{ fontSize: 20 }} />
            Quick Navigation
          </h5>

          <Row>
            {/* <Col md={4} sm={6} xs={12} className="mb-4">
              <Card
                style={{
                  padding: "20px",
                  textAlign: "left",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  height: "100%",
                  border: "none",
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardContent
                  style={{
                    padding: "0",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "12px",
                    }}
                  >
                    <DomainIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      style={{ color: "#2c3e50" }}
                    >
                      Manage Institutes
                    </Typography>
                  </div>
                  <Typography
                    variant="body2"
                    style={{
                      marginBottom: "20px",
                      color: "#7f8c8d",
                      fontSize: "14px",
                      lineHeight: "1.4",
                      flex: 1,
                    }}
                  >
                    You can manage the Institutes on the portal by clicking on
                    below button
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "auto",
                    }}
                  >
                    <button
                      style={{
                        padding: "8px 20px",
                        borderRadius: "6px",
                        border: "1px solid #2f80ed",
                        backgroundColor: "transparent",
                        color: "#2f80ed",
                        fontWeight: "500",
                        cursor: "pointer",
                        fontSize: "14px",
                        transition: "all 0.2s ease",
                        minWidth: "120px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#2f80ed";
                        e.target.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#2f80ed";
                      }}
                      onClick={handleInstitutesClick}
                    >
                      Manage Institutes
                    </button>
                  </div>
                </CardContent>
              </Card>
            </Col> */}

            <Col md={6} sm={6} xs={12} className="mb-4">
              <Card
                style={{
                  padding: "20px",
                  textAlign: "left",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  height: "100%",
                  border: "none",
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardContent
                  style={{
                    padding: "0",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "12px",
                    }}
                  >
                    <MarkEmailReadIcon
                      fontSize="small"
                      style={{ color: "#e74c3c" }}
                    />
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      style={{ color: "#2c3e50" }}
                    >
                      Mass Email Communication
                    </Typography>
                  </div>
                  <Typography
                    variant="body2"
                    style={{
                      marginBottom: "20px",
                      color: "text.secondary",
                      fontSize: "14px",
                      lineHeight: "1.4",
                      flex: 1,
                    }}
                  >
                    Send targeted emails to students and institutes in your
                    region and city. Enhance communication efficiency with
                    filtered email campaigns.
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "auto",
                    }}
                  >
                    <button
                      style={{
                        padding: "8px 20px",
                        borderRadius: "6px",
                        border: "1px solid #e74c3c",
                        backgroundColor: "transparent",
                        color: "#e74c3c",
                        fontWeight: "500",
                        cursor: "pointer",
                        fontSize: "14px",
                        transition: "all 0.2s ease",
                        minWidth: "120px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#e74c3c";
                        e.target.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#e74c3c";
                      }}
                      onClick={handleMassEmailClick}
                    >
                      Manage Mass Email
                    </button>
                  </div>
                </CardContent>
              </Card>
            </Col>

            <Col md={6} sm={6} xs={12} className="mb-4">
              <Card
                style={{
                  padding: "20px",
                  textAlign: "left",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  height: "100%",
                  border: "none",
                  backgroundColor: "white",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CardContent
                  style={{
                    padding: "0",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "12px",
                    }}
                  >
                    <HistoryIcon
                      fontSize="small"
                      style={{ color: "#9b59b6" }}
                    />
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      style={{ color: "#2c3e50" }}
                    >
                      Email History
                    </Typography>
                  </div>
                  <Typography
                    variant="body2"
                    style={{
                      marginBottom: "20px",
                      color: "text.secondary",
                      fontSize: "14px",
                      lineHeight: "1.4",
                      flex: 1,
                    }}
                  >
                    View and track all emails you've sent through the mass email
                    system. Monitor delivery status and recipient engagement.
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "auto",
                    }}
                  >
                    <button
                      style={{
                        padding: "8px 20px",
                        borderRadius: "6px",
                        border: "1px solid #9b59b6",
                        backgroundColor: "transparent",
                        color: "#9b59b6",
                        fontWeight: "500",
                        cursor: "pointer",
                        fontSize: "14px",
                        transition: "all 0.2s ease",
                        minWidth: "120px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#9b59b6";
                        e.target.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#9b59b6";
                      }}
                      onClick={handleEmailHistoryClick}
                    >
                      View Email History
                    </button>
                  </div>
                </CardContent>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </div>
  );

  return isLoading ? (
    <Loader />
  ) : (
    <div className={css.outerDiv}>

      {/* Tab Navigation */}
      <div className="my-4">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#f9fbfd",
            borderRadius: 8,
            marginBottom: "20px",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e, v) => setActiveTab(v)}
            textColor="primary"
            TabIndicatorProps={{ style: { display: "none" } }}
            sx={{
              backgroundColor: "#f2f4f7",
              borderRadius: "8px",
              padding: "6px",
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                minHeight: 40,
                borderRadius: "8px",
                marginX: "8px",
                padding: "6px 16px",
                marginRight: 1,
                color: "#4f4f4f",
                "& .MuiSvgIcon-root": {
                  color: "#4f4f4f",
                },
              },
              "& .Mui-selected": {
                backgroundColor: "#2f80ed",
                color: "#fff",
                "& .MuiSvgIcon-root": {
                  color: "#fff",
                },
              },
            }}
          >
            <Tab
              value="overview"
              icon={<DataUsageIcon fontSize="small" />}
              label="Overview"
              iconPosition="start"
            />
            <Tab
              value="yuva"
              icon={<AccountBalanceIcon fontSize="small" />}
              label="YUVA"
              iconPosition="start"
            />
            <Tab
              value="thalir"
              icon={<SchoolIcon fontSize="small" />}
              label="Thalir"
              iconPosition="start"
            />
          </Tabs>
        </div>

        {/* Conditional Rendering for Tabs */}
        {activeTab === "overview" && renderOverviewTab()}
        {activeTab === "yuva" && renderYUVATab()}
        {activeTab === "thalir" && renderThalirTab()}

        {/* Quick Navigation - Show only in Overview tab */}
        {renderQuickNavigation()}
      </div>
    </div>
  );
};

export default EMServicePage;